import React from "react";

export default function CheckerBackground({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div className="checker-bg absolute -right-10 -top-10 h-48 w-48 opacity-[0.04] rotate-12" />
      <div className="checker-bg absolute -bottom-16 -left-10 h-56 w-56 opacity-[0.04] -rotate-6" />
    </div>
  );
}
